"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _slice = require("@lce/slice");

var Styled = _interopRequireWildcard(require("./CheckoutButton.style"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

var CheckoutButton = function CheckoutButton(_a) {
  var count = _a.count,
      disabled = _a.disabled,
      onClick = _a.onClick,
      t = _a.t;
  var hasNoItems = count === 0;
  return React.createElement(_slice.Box, {
    mb: 3
  }, React.createElement(Styled.CheckoutButton, {
    "data-testid": "mini-cart__checkout-button",
    disabled: hasNoItems || disabled,
    onClick: onClick
  }, t('Common.Checkout')));
};

var _default = CheckoutButton;
exports["default"] = _default;